import { sortedTagsList } from "./getSortedTags";

const getSortedTagPairs = (
  tags: any,
  tagsEn: any,
): { display: string[]; en: (string | undefined)[] } => {
  const safeTags: any[] = Array.isArray(tags) ? tags : [];
  const safeEn: any[] = Array.isArray(tagsEn) ? tagsEn : [];

  const length = Math.max(safeTags.length, safeEn.length);

  const pairs: Array<{ display: string; en: string | undefined }> = [];
  for (let i = 0; i < length; i += 1) {
    const rawDisplay = safeTags[i];
    const rawEn = safeEn[i];
    // Mirror getSortedTags: drop the CRM "not_available" placeholder.
    if (rawDisplay !== "not_available" && rawEn !== "not_available") {
      pairs.push({
        display: (rawDisplay ?? "").replace(/_/g, " "),
        en: rawEn != null ? rawEn.replace(/_/g, " ") : undefined,
      });
    }
  }

  pairs.sort((a, b) => {
    const aKey = (a?.en ?? a?.display)?.toLowerCase();
    const bKey = (b?.en ?? b?.display)?.toLowerCase();
    if (sortedTagsList?.indexOf(bKey as any) === -1) return -1;
    if (sortedTagsList?.indexOf(aKey as any) === -1) return 1;
    return (
      (sortedTagsList?.indexOf(aKey as any) ?? -1) - (sortedTagsList?.indexOf(bKey as any) ?? -1)
    );
  });

  return {
    display: pairs.map((pair) => pair.display),
    en: pairs.map((pair) => pair.en),
  };
};

export default getSortedTagPairs;
